export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["名称："])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["保存"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请为资产提供一个新名称"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["这个名称将帮助您在资产列表中更容易识别钱包。"])}
}